import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconTankdemontageErdgas: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 145.7 121.6" style={{ color }} xmlSpace="preserve">
      <g fill="currentColor">
        <path d="M123.5,89.7c-1.1-0.7-2.5-0.3-3.1,0.7C104,116.8,69.3,125,43,108.6C24.7,97.3,14.4,76.3,16.7,54.9l9.1,9.3L29,61L16.2,48
          c-0.9-0.9-2.3-0.9-3.2,0L0,60.7L3.2,64l8.9-8.7C10,78,21,100.4,40.6,112.5c9.9,6.2,21,9.1,31.9,9.1c20.3,0,40.3-10.2,51.7-28.7
          C124.9,91.8,124.5,90.4,123.5,89.7z"/>
        <path d="M142.5,55.3l-9.3,9.3c1.4-22.2-9.6-43.6-28.6-55.4C76.1-8.5,38.6,0.3,21,28.7c-0.7,1.1-0.3,2.5,0.7,3.1
          c1.1,0.7,2.5,0.3,3.1-0.7C41.1,4.8,75.9-3.4,102.2,13c17.5,10.9,27.7,30.7,26.5,51.1l-8.8-8.8l-3.2,3.2l12.9,12.9
          c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7l12.9-12.9L142.5,55.3z"/>
        <path d="M62.2,57.5c-0.4-0.5-1-0.8-1.7-0.8c0,0,0,0,0,0c-0.7,0-1.3,0.3-1.7,0.8c-1.4,1.6-5.9,7.1-5.9,10.5c0,0.2,0,0.4,0,0.7
          c0.2,4.1,3.6,7.3,7.6,7.3c0.1,0,0.2,0,0.3,0c2-0.1,3.9-1,5.3-2.5c1.4-1.5,2.1-3.4,2-5.4C68.1,64.5,63.6,59.1,62.2,57.5z M62.8,70.4
          c-0.6,0.6-1.3,1-2.2,1c-1.7,0.1-3.2-1.3-3.2-3c0-0.1,0-0.2,0-0.4c0-0.9,1.4-3.3,3.1-5.6c1.7,2.2,3.1,4.6,3.1,5.6c0,0,0,0.1,0,0.1
          C63.6,69,63.3,69.8,62.8,70.4z"/>
        <path d="M66.8,42.3H54.5c-1.2,0-2.3,1-2.3,2.3v4.1c-8.5,1.2-15.1,8.4-15.3,17.2c-0.1,4.8,1.6,9.3,4.9,12.7s7.7,5.4,12.5,5.5h37.2
          c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0,0.5,0c4.8-0.1,9.2-2.1,12.5-5.5c3.3-3.4,5-8,4.9-12.7c-0.1-4.8-2.1-9.2-5.5-12.5
          c-3.4-3.3-8-5-12.7-4.9l-22.5,0v-4C69.1,43.3,68.1,42.3,66.8,42.3z M56.7,46.8h7.8v1.7h-7.8V46.8z M91.6,53
          c3.5-0.1,6.9,1.2,9.5,3.7c2.6,2.4,4,5.7,4.1,9.3c0.1,3.5-1.2,6.9-3.7,9.5c-2.4,2.6-5.7,4-9.3,4.1c-0.2,0-0.4,0-0.7,0c0,0,0,0-0.1,0
          l-37.2,0c-3.5-0.1-6.9-1.6-9.3-4.1c-2.4-2.6-3.7-5.9-3.7-9.5c0.2-7.1,5.9-12.8,12.9-12.9h0.2l0,0h12.3c0,0,0,0,0,0L91.6,53z"/>
      </g>
    </svg>
  );
};
